var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.estates.length > 0
    ? _c(
        "div",
        { staticClass: "tecnomap-estates" },
        [
          _c(
            "my-carousel",
            {
              attrs: {
                "per-page": 1,
                "pagination-enabled": true,
                "navigation-enabled": false,
                "min-swipe-distance": 2,
                "show-title": true
              }
            },
            [
              _vm._l(_vm.estates, function(estate) {
                return [
                  _c(
                    "slide",
                    { key: estate.id, attrs: { title: estate.title } },
                    [
                      _c(
                        "div",
                        { staticClass: "tecnomap-estate-card" },
                        [
                          _c("estate-card", {
                            attrs: {
                              estate: estate,
                              extLang: _vm.extLang,
                              showActions: _vm.showActions
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }